import React, { useState } from 'react';
import aititleicon from '@/assets/ai/aititleicon.png';
import aivideocard3 from '@/assets/ai/video/aivideocard3.mp4';
import aivideocard1 from '@/assets/ai/video/aivideocard1.mp4';
import aivideocard2 from '@/assets/ai/video/aivideocard2.mp4';
import './card.css';

function Card() {
    const [active, setActive] = useState('right'); // 默认激活右侧卡片

    const handleMouseEnter = (card) => {
        setActive(card);
    };

    const handleMouseLeave = () => {
        setActive('right'); // 恢复默认状态
    };

    return (
        <div
            className="container"
            onMouseLeave={handleMouseLeave} // 当鼠标离开整个容器时恢复默认
        >
            <div
                className={`card left ${active === 'left' ? 'active' : 'collapsed'}`}
                onMouseEnter={() => handleMouseEnter('left')}
            >
                {active === 'left' ? (
                    <div className='w-[844px] mt-44 relative'>
                        <video className="absolute bottom-[29px] right-[-80px] z-0" loop autoPlay muted>
                            <source src={aivideocard1} type="video/mp4" />
                        </video>
                        <div className='relative z-[1]'>
                            <p className='text-[28px] flex items-center'>
                                <img src={aititleicon} alt="" className='w-[34px] h-[34px]' />
                                <span className='ml-8'>
                                    Interactive Chats,
                                    Personalized Growth
                                </span>
                            </p>
                            <p className='text-base text-[#9F9F9F] mt-3 ml-16'>
                                Engage in real chats with Aya. Discuss game strategies, set goals, or even explore broader interests. Powered by advanced LLMs, Aya learns and evolves, becoming a smart companion tailored to your unique preferences.
                            </p>
                        </div>
                    </div>
                ) : (
                    <p className='absolute top-30 left-1/2 transform -translate-x-1/2 -rotate-90 text-[#3633F7] text-3xl font-semibold	 whitespace-nowrap text-center'>
                        Interactive Chats, <br />Personalized Growth
                    </p>
                )}
            </div>
            <div
                className={`card middle ${active === 'middle' ? 'active' : 'collapsed'}`}
                onMouseEnter={() => handleMouseEnter('middle')}
            >
                {active === 'middle' ? (
                    <div className='w-[844px] mt-44 relative'>
                        <video className="absolute bottom-[29px] right-[-80px] z-0" loop autoPlay muted>
                            <source src={aivideocard2} type="video/mp4" />
                        </video>
                        <div className='relative z-[1]'>
                            <p className='text-[28px] flex items-center'>
                                <img src={aititleicon} alt="" className='w-[34px] h-[34px]' />
                                <span className='ml-8'>
                                    Creating Game Assets
                                </span>
                            </p>
                            <p className='text-base text-[#9F9F9F] mt-3 ml-16'>
                                Aya isn’t just a companion—she’s a creator. Collaborate with Aya to design unique game assets, including characters, items, levels, and environments. Using AIGC technology, Aya transforms your ideas into reality, supporting NFT integration and gamification.
                            </p>
                        </div>
                    </div>
                ) : (
                    <p className='absolute top-30 left-1/2 transform -translate-x-1/2 -rotate-90 text-[#3633F7] text-3xl font-semibold	 whitespace-nowrap text-center'>
                        Creating Game Assets
                    </p>
                )}
            </div>
            <div
                className={`card right ${active === 'right' ? 'active' : 'collapsed'}`}
                onMouseEnter={() => handleMouseEnter('right')}
            >
                {active === 'right' ? (
                    <div className='w-[844px] mt-44 relative'>
                        <video className="absolute bottom-[29px] right-[-80px] z-0" loop autoPlay muted>
                            <source src={aivideocard3} type="video/mp4" />
                        </video>
                        <div className='relative z-[1]'>
                            <p className='text-[28px] flex items-center'>
                                <img src={aititleicon} alt="" className='w-[34px] h-[34px]' />
                                <span className='ml-8'>
                                    Autonomous Actions & Player Support
                                </span>
                            </p>
                            <p className='text-base text-[#9F9F9F] mt-3 ml-16'>
                                Aya autonomously executes complex in-game tasks, optimizes strategies, and enhances your overall gaming experience. By analyzing your playstyle, she provides real-time recommendations and solutions, unlocking new possibilities within your gameplay.
                            </p>
                        </div>
                    </div>
                ) : (
                    <p className='absolute top-30 left-1/2 transform -translate-x-1/2 -rotate-90 text-[#3633F7] text-3xl font-semibold	 whitespace-nowrap text-center'>
                        Autonomous Actions <br />& Player Support
                    </p>
                )}
            </div>
        </div>
    );
}

export default Card;
